import { track } from '../utils/analytics'

// The public "northern vs southern" guide is plain ERB (no Vue) — wire up the
// side-by-side audio buttons and CTA tracking with delegated listeners.
// Mirrors phrasebook.js but with data-dg-* attributes and its own events, so
// this page's funnel doesn't get mixed into the phrasebook's.
let bound = false

export function mountDialectGuide() {
  if (bound || !document.querySelector('[data-dg-cta], [data-dg-audio]')) return
  bound = true

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-dg-audio]')
    if (button) {
      try {
        new Audio(button.dataset.playAudio).play().catch(() => {})
        // "south:Sắc" / "north:mẹ" — dialect is the interesting dimension here:
        // it tells us which accent readers actually came to hear.
        const [dialect, label] = (button.dataset.dgAudio || '').split(':')
        track('dialect_guide_audio_played', { dialect: dialect || null, label: label || null })
      } catch (_e) {
        // Missing/blocked audio should never break the page.
      }
      return
    }

    const cta = event.target.closest('[data-dg-cta]')
    if (cta) {
      track('dialect_guide_cta_clicked', {
        destination: cta.dataset.dgCta,               // demo | tone_trainer
        location: cta.dataset.dgLocation || 'unknown', // nav | tones | footer
      })
    }
  })
}
